export const SPLASH_CONFIG = {
    minDisplayTime: 2500,
    maxDisplayTime: 5000,
    backgroundColor: '#021a12',
    gradientColors: {
        start: '#042f1a',
        middle: '#022c22',
        end: '#021a12'
    },
    logo: {
        src: '/icons/terriqon/terriqon-fieldops-logo-light.svg',
        alt: 'Terriqon Logo',
        height: '60px',
        fallbackText: 'Terriqon'
    },
    content: {
        title: 'Terriqon',
        subtitle: 'Field Data Collection',
        description: 'Field-first Monitoring & Evaluation (M&E) platform',
    },
    animations: {
        fadeOutDuration: 800,
        enableParticles: true,
        enableProgressBar: true
    },
    skipInDevelopment: false,
    waitForDataLoad: true,
    dataLoadTimeout: 4000
};

if (import.meta.env.DEV && SPLASH_CONFIG.skipInDevelopment) {
    SPLASH_CONFIG.minDisplayTime = 0;
    SPLASH_CONFIG.maxDisplayTime = 0;
}
